import { useMemo } from "react";
import { PriceSummary } from "../PriceSummary";
import { CartItem } from "@ecommerce/store";
import { AppliedCouponDiscount, AppliedCouponDiscountFields } from "../../../types/purchaseOrder/couponTypes";
import { OrderCalculationView, OrderCalculationViewFields } from "../../../types/purchaseOrder/Order";

export const usePriceCalculator = (
  cartItems: CartItem[], 
  appliedCouponDiscount?: AppliedCouponDiscount | null,
  deliveryPrice: number = 0,
  calculationData?: OrderCalculationView | null,
  isShippingToBeAgreed: boolean = false
): PriceSummary => {
  return useMemo(() => {
    if (calculationData) {
      const subtotal = calculationData[OrderCalculationViewFields.Subtotal];
      const shippingCost = calculationData[OrderCalculationViewFields.ShippingCost];
      const shippingDiscount = calculationData[OrderCalculationViewFields.ShippingDiscount];
      const productsDiscount = calculationData[OrderCalculationViewFields.ProductsDiscount];
      const total = calculationData[OrderCalculationViewFields.Total];
      
      const finalShippingCost = shippingCost - shippingDiscount;
      
      return { 
        subtotal, 
        discount: productsDiscount, 
        shipping: finalShippingCost,
        shippingOriginalCost: shippingCost,
        shippingDiscount: shippingDiscount,
        shippingApplyCoupon: shippingDiscount > 0,
        isShippingToBeAgreed,
        total
      };
    }
    
    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    
    if (appliedCouponDiscount) {
      const originalTotal = appliedCouponDiscount[AppliedCouponDiscountFields.OriginalTotal];
      const discountedTotal = appliedCouponDiscount[AppliedCouponDiscountFields.DiscountTotal];
      const freeShipping = appliedCouponDiscount[AppliedCouponDiscountFields.FreeShipping];
      const discount = originalTotal - discountedTotal;
      
      const shippingCost = freeShipping ? 0 : deliveryPrice;
      
      return { 
        subtotal, 
        discount, 
        shipping: shippingCost,
        shippingOriginalCost: freeShipping ? deliveryPrice : undefined,
        shippingDiscount: freeShipping ? deliveryPrice : 0,
        shippingApplyCoupon: freeShipping,
        isShippingToBeAgreed,
        total: discountedTotal + shippingCost
      };
    }
    
    return { 
      subtotal, 
      discount: 0, 
      shipping: deliveryPrice,
      shippingOriginalCost: undefined,
      shippingDiscount: 0,
      shippingApplyCoupon: false,
      isShippingToBeAgreed,
      total: subtotal + deliveryPrice 
    };
  }, [cartItems, appliedCouponDiscount, deliveryPrice, calculationData]);
};














